import React from 'react';
import { Button } from 'app/components';
import './style';

const MobileBanner = ({
  id,
  Announcement = true,
  heading,
  subtitle,
  label,
  color,
}) => {
  return (
    <>
      <div className="flex flex-col w-full items-center justify-center p-6 md:hidden">
        <div className="w-[327px] bg-[#FDFDFD] rounded-[24px] flex flex-col items-center">
          <div className="w-full h-[50px] bg-[#E5FFF6] rounded-t-[24px] flex items-center justify-center px-6">
            <img src="assets/images/Speaker.svg" alt="Speaker Icon" className="w-6 h-6 mr-2"
            />
            <span className="text-[#009D64] text-sm font-medium">
              New Event ticketing platform in town!
            </span>
          </div>
          <div className="w-full bg-[#101010] rounded-b-[24px] flex flex-col items-center p-6 gap-6">
            <h1 className="text-[24px] font-semibold text-white leading-[135%] text-left">
              Create Events, Sell Tickets, Grow Your Audience – All for
              <br />
              <span className="text-[#FF2459]">
                Free!
              </span>
            </h1>
            <Button type="primary" rounded="true"
                    onClick={() => {
                      window.open(
                        "/landing",
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                  >
                    List your event
            </Button>
          </div>
        </div>
      </div>
      </>
  );
};

export default MobileBanner;
